<template>
  <v-dialog
    v-model="dialogOpcao"
    max-width="620px"
    class="rounded-lg"
    persistent
    scrollable
  >
    <v-card class="base rounded-lg" tile>
      <v-toolbar flat dark color="base">
        <v-toolbar-title>
          Configurações da opção
          <strong
            ><u>
              {{ opcaoItem.descricao }}
            </u></strong
          >
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="mt-0 mr-0" dark icon @click="close">
          <CloseIcon />
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-list three-line subheader class="rounded-t-lg">
          <v-subheader class="font-weight-bold">Traduções</v-subheader>
          <v-list-item>
            <v-list-item-content class="py-0">
              <v-row class="d-flex">
                <v-col cols="6">
                  <BaseTextField
                    v-model="opcaoItem.descricao_en_us"
                    label="Inglês"
                    placeholder="Ex: Adult"
                    hide-details
                  />
                </v-col>
                <v-col cols="6">
                  <BaseTextField
                    v-model="opcaoItem.descricao_es_es"
                    label="Espanhol"
                    placeholder="Ex: Adulto"
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-subheader class="font-weight-bold">Geral</v-subheader>
          <v-list-item>
            <v-list-item-content>
              <v-row>
                <v-col cols="6">
                  <BaseTextField
                    v-model="opcaoItem.prioridade"
                    label="Prioridade"
                    placeholder="Ex: 1"
                    persistent-hint
                    hint="A opção com menor número de prioridade irá aplicar preço e quantidade as variações."
                  />
                </v-col>
              </v-row>
              <v-row class="d-flex justify-start">
                <v-col cols="6">
                  <BaseMoneyField
                    label="Preço"
                    placeholder="Ex: 100,00"
                    v-model="opcaoItem.preco_default"
                    :options="moneyFieldConfig"
                    :hideDetails="false"
                    :persistentHint="true"
                    :hint="'O preço definido neste campo será aplicado para todas variações que possuírem esta opção.'"
                  ></BaseMoneyField>
                </v-col>
                <v-col cols="6">
                  <BaseTextField
                    v-model="opcaoItem.qtd_default"
                    label="Quantidade"
                    placeholder="Ex: 100"
                    persistent-hint
                    hint="A quantidade definida neste campo será aplicada para todas variações que possuírem esta opção."
                  />
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader class="rounded-b-lg">
          <v-subheader class="font-weight-bold"
            >Cortesia/Gratuídade</v-subheader
          >
          <v-radio-group v-model="opcaoItem.taxa" class="mx-4">
            <template v-slot:label>
              <div>Selecione se essa opção é:</div>
            </template>
            <v-radio
              value="GRATUIDADE"
              class="rounded-lg pa-2"
              style="border: 1px solid rgb(0 0 0 / 42%)"
              active-class="active-class"
            >
              <template v-slot:label>
                <div>
                  Gratuídade<br />
                  <small
                    >Aplicar gratuídade a todas variações que possuírem esta
                    opção.</small
                  >
                </div>
              </template>
            </v-radio>
            <v-radio
              value="CORTESIA"
              class="rounded-lg pa-2"
              style="border: 1px solid rgb(0 0 0 / 42%)"
              active-class="active-class"
            >
              <template v-slot:label>
                <div>
                  Cortesia<br />
                  <small
                    >Aplicar cortesia a todas variações que possuírem esta
                    opção.</small
                  >
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-list>
      </v-card-text>
      <v-card-actions class="pr-6 pb-4">
        <v-spacer></v-spacer>
        <v-btn class="order-2 rounded-lg" dark dense @click="save"
          >Salvar</v-btn
        >
        <v-btn
          class="rounded-lg mr-4 order-1"
          color="transparent"
          elevation="0"
          @click="close"
          >Cancelar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BaseMoneyField from "@/components/forms/BaseMoneyField.vue";
// import VuetifyMoney from "@/components/global/VuetifyMoney.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import CloseIcon from "@/components/icons/CloseIcon.vue";
import products from "@/mixins/products.js";
export default {
  name: "OptionConfigDialog",
  components: {
    BaseMoneyField,
    // VuetifyMoney,
    BaseTextField,
    CloseIcon,
  },
  mixins: [products],
  data() {
    return {
      moneyFieldConfig: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 9,
        precision: 2,
      },
    };
  },
  props: {
    dialogOpcao: {
      type: Boolean,
    },
    opcaoItem: {
      type: Object,
    },
    defaultOpcaoItem: {
      type: Object,
    },
    opcaoIndex: {
      type: Number,
    },
    idx: {
      type: Number,
    },
    optionValor: {
      type: Array,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      if (this.opcaoIndex > -1) {
        Object.assign(
          this.$produtos_gerenciar.cadastro.variacoes.opcoes[this.idx].valor[
            this.opcaoIndex
          ],
          this.opcaoItem
        );
        Object.assign(this.optionValor[this.opcaoIndex], this.opcaoItem);
      } else {
        this.$produtos_gerenciar.cadastro.variacoes.opcoes[this.idx].valor.push(
          this.opcaoItem
        );
      }

      this.$emit("changeVariations");

      this.close();
    },
  },
  watch: {
    dialogOpcao(val) {
      val || this.close();
    },
  },
};
</script>

<style scoped>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
</style>
